import styled, { css } from "styled-components";

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;

  ${({ width }: any) =>
    css`
      width: ${width ?? "100%"};
    `}

  &:not(:last-child) {
    margin-right: 32px;
  }

  ${({ alignTextRight }: any) =>
    alignTextRight &&
    css`
      && .MuiTypography-subtitle1 {
        text-align: right;
      }
    `}
`;

export const GroupRow = styled.div`
  display: flex;
  flex-direction: row;

  :not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const Container = styled.div`
  width: 418px;
  margin-bottom: 40px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ButtonContainer = styled.div`
  display: flex;

  width: 100px;

  &:not(:last-child) {
    margin-right: 30px;
  }
`;
